// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalScroll_wrapper__j4b_L","wrapperNoPadding":"ModalScroll_wrapperNoPadding__jG_r4"};